{
  "name": "@medflyt/eslint-plugin-graphql-type-checker",
  "version": "5.1.3",
  "description": "ESLint plugin that generates & validates TypeScript type annotations for GraphQL queries",
  "main": "./dist/rules.js",
  "author": "MedFlyt",
  "license": "MIT",
  "keywords": [
    "eslint",
    "plugin",
    "gql",
    "template",
    "literal",
    "graphql",
    "typescript",
    "validation",
    "generated",
    "types",
    "typings"
  ],
  "files": [
    "dist/**/*"
  ],
  "repository": {
    "type": "git",
    "url": "git+https://github.com/MedFlyt/eslint-plugin-graphql-type-checker.git"
  },
  "bugs": {
    "url": "https://github.com/MedFlyt/eslint-plugin-graphql-type-checker/issues"
  },
  "homepage": "https://github.com/MedFlyt/eslint-plugin-graphql-type-checker#readme",
  "scripts": {
    "typecheck": "tsc --noEmit",
    "build": "tsup",
    "build:watch": "pnpm build --watch",
    "clean": "rm -rf dist",
    "install:demo": "cd src/demo && pnpm install",
    "lint-demo": "eslint --ext .ts src/demo/queries",
    "lint-demo:watch": "nodemon --watch dist --watch src/demo/queries --exec 'pnpm lint-demo-queries'",
    "prepublishOnly": "pnpm clean && pnpm build && pnpm test",
    "prettier": "prettier -l '**/*.{ts,tsx,js,scss}'",
    "prettier:fix": "pnpm run prettier --write",
    "test": "vitest run",
    "test:watch": "npm vitest"
  },
  "dependencies": {
    "@prettier/sync": "^0.3.0",
    "@typescript-eslint/parser": "^6.13.1",
    "@typescript-eslint/utils": "^6.13.1",
    "graphql": "^16.8.1",
    "prettier": "^3.1.0",
    "zod": "^3.20.2",
    "zod-to-json-schema": "3.22.1"
  },
  "devDependencies": {
    "@types/eslint": "^8.44.7",
    "@types/json-schema": "^7.0.11",
    "@types/node": "^18.11.19",
    "@types/prettier": "^3.0.0",
    "@typescript-eslint/eslint-plugin": "^6.13.1",
    "@typescript-eslint/rule-tester": "^6.13.1",
    "eslint": "^8.54.0",
    "graphql-tag": "^2.12.6",
    "tsup": "^8.0.1",
    "typescript": "^5.3.2",
    "vitest": "^0.34.6"
  },
  "peerDependencies": {
    "graphql": "^16.8.1"
  }
}
